import {NavLink} from "react-router-dom";
import {hsoIdApi, useLogoutMutation} from "../services/hsoid";
import {clearAuthData} from "../features/authentication/reducer";
import React from "react";
import {ReactComponent as SynturaLogoWhite} from "../../Syntura_logo_white.svg";
import {useAppDispatch} from "../hooks";


export const HeaderBar = () => {

    const dispatch = useAppDispatch();
    const [logout] = useLogoutMutation();

    return(
        <nav className="navbar is-black">
                <div className="container">
                <div className="navbar-brand">
                    <a className="navbar-item" href="/">
                        <SynturaLogoWhite style={{height: '30px'}}/>
                    </a>

                    <a role="button" className="navbar-burger" aria-label="menu" aria-expanded="false"
                       data-target="navbarBasicExample">
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </a>
                </div>
                <div id="navbarBasicExample" className="navbar-menu">
                    <div className="navbar-start">
                        <NavLink to={"/"} className={({ isActive }) =>
                            isActive ? 'navbar-item is-active' : 'navbar-item is-primary'
                          }>
                            Home
                        </NavLink>
                        <NavLink to={"/mfa"}  className={({ isActive }) =>
                            isActive ? 'navbar-item is-active' : 'navbar-item is-primary'
                          }>
                            MFA
                        </NavLink>
                        <NavLink to="/clients" className={({ isActive }) =>
                            isActive ? 'navbar-item is-active' : 'navbar-item is-primary'
                          }>
                            API Clients
                        </NavLink>
                    </div>
                </div>
                <div className="navbar-end">
                    <a className="navbar-item" href={process.env.REACT_APP_CUSTOMER_PORTAL_URL}>
                        Portal
                    </a>

                    <a className="navbar-item" onClick={async () => {
                        await logout();
                        dispatch(hsoIdApi.util.resetApiState());
                        dispatch(clearAuthData());
                    }}>
                        Logout
                    </a>

                </div>
                    </div>
            </nav>
    )
}
